import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Button, Checkbox, Dimmer, Icon, Input, Loader, Modal } from 'semantic-ui-react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import styled from 'styled-components';
import {
    getAtriutoAplicarListAction,
    getAtributoGeralAction,
    getAtributoDeleteAction,
    changeTabAction,
    getAtributoUpdateAction
} from '../../../actions/EspacoTecaActions';

const Container = styled.div`
  margin-top: 20px;
  margin-bottom: 20px;
  height: 300px;
  border: 1px solid #dededf;
  border-radius: 8px;
  overflow-y: auto;
  background: #fff;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);

  &::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  &::-webkit-scrollbar-track {
    background: #f2f3f5;
    border-radius: 8px;
  }

  &::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 8px;
    transition: background 0.2s ease;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
  }
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  font-size: 0.9rem;
`;

const Th = styled.th`
  text-align: left;
  background: #102E3E;
  padding: 10px;
  color: #fff;
  font-weight: 600;
  position: sticky;
  top: 0;
  z-index: 1;
`;

const Td = styled.td`
  padding: 5px 10px;
  border-bottom: 1px solid #eee;
  color: #444;
  vertical-align: middle;
`;

const Status = styled.span`
  width: '200px';
  padding: 6px 10px;
  border-radius: 6px;
  font-weight: 500;
  color: ${(props) =>
        props.value === "<vazio>"
            ? "#fff"
            : props.value === props.valorParaInput
                ? "#1a421a"
                : "#222"};
  background-color: ${(props) =>
        props.value === "<vazio>"
            ? "#e63946"
            : props.value === props.valorParaInput
                ? "#b7e4c7"
                : "#ffb703"};
`;

const ActionButton = styled(Button)`
  && {
    color: white;
    background-color: #D73A49;
    font-weight: 600;
    padding: 6px 8px;
    font-size: 0.85rem;
  }

  &&:hover {
    background-color: #B12E3B;
    color: white;
  }
`;
const ActionButtonSelect = styled(Button)`
  && {
    color: white !important;
    background-color: ${({ selected }) => (selected ? '#D73A49' : '#0078d7')} !important;
    font-weight: 600;
    padding: 6px 8px;
    font-size: 0.85rem;
    transition: background-color 0.15s ease;
  }

  &&:hover {
    background-color: ${({ selected }) => (selected ? '#B12E3B' : '#005ea3')} !important;
    color: white !important;
  }

  &&:focus,
  &&:active {
    background-color: ${({ selected }) => (selected ? '#D73A49' : '#0078d7')} !important;
    color: white !important;
    box-shadow: none !important;
  }
`;

const Footer = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 10px;
  background: #f8f9fb;
  border-top: 1px solid #dededf;
`;

const ApplyButton = styled(Button)`
  && {
    background: #0078d7;
    color: white;
    font-weight: 600;
    border-radius: 6px;
    padding: 8px 16px;
  }

  &&:hover {
    background: #005ea3;
  }
`;

const StyledModalHeader = styled(Modal.Header)`
  display: flex !important;
  flex-direction: column !important;
  align-items: center !important;
  padding-bottom: 0 !important;
  border-bottom: none !important;
`;

const ModalTitle = styled.h2`
  font-weight: 700 !important;
  margin-top: '10px' !important;
  margin-bottom: 1em !important;
`;

const StyledModalContent = styled(Modal.Content)`
  display: flex !important;
  flex-direction: column !important;
  align-items: center !important;
  text-align: center !important;
`;

const StyledModalActions = styled(Modal.Actions)`
  display: flex !important;
  justify-content: center !important;
  gap: 1rem !important;
  padding-bottom: 2em !important;
  border-top: none !important;
`;

const Tr = styled.tr`
  background-color: ${({ selected }) => (selected ? '#e6f3ff' : 'transparent')};
  transition: background-color 0.2s ease-in-out;
`;

function Aplicar(props) {
    const {
        atributosItemList = [],
        atributosList = [],
        atributoSelecionado = null,
        tabindex,
        atributosAplicarList = [], // default safe
        atributosAplicarListLoading,
        atributosAplicarGeral,
        atributosAplicarGeralLoading,
        getAtriutoAplicarListAction, // from connect
        getAtributoGeralAction, // from connect
        getAtributoDeleteAction,
        atributosAplicarDelete,
        atributosAplicarDeleteLoading,
        atributosAplicarEdit,
        atributosAplicarEditLoading,
        getAtributoUpdateAction
    } = props;

    const [openModalEditar, setOpenModalEditar] = useState(false);
    const [openModalExcluirSKU, setOpenModalExcluirSKU] = useState(false);
    const [skuExcluir, setSkuExcluir] = useState();
    const [loadingEditar, setLoadingEditar] = useState(false);
    const [reload, setReload] = useState(false);
    const [atributoValorIdExcluir, setAtributoValorIdExcluir] = useState();
    const [selecionados, setSelecionados] = useState([]); // SKUs selecionados (persistente entre filtros)
    const [todosSelecionados, setTodosSelecionados] = useState(false);
    const [selectedSku, setSelectedSku] = useState(false); // SKUs selecionados na tabela atual

    // filtros
    const [valorFiltroDigitado, setValorFiltroDigitado] = useState('');
    const [valorFiltro, setValorFiltro] = useState('');
    const [categoria, setCategoria] = useState('');
    const [sku, setSku] = useState('');
    const [produto, setProduto] = useState('');
    const [valorFiltroAplicados, setValorFiltroAplicados] = useState('');
    const [categoriaAplicados, setCategoriaAplicados] = useState('');
    const [skuAplicados, setSkuAplicados] = useState('');
    const [produtoAplicados, setProdutoAplicados] = useState('');
    const [usarMesmoValor, setUsarMesmoValor] = useState(false);

    // refs separados para cada container/table
    const rootRef = useRef(null);
    const firstTableRef = useRef(null);
    const secondTableRef = useRef(null);

    // proteções e derived values
    const primeiroAtributoItem = atributosItemList && atributosItemList.length > 0 ? atributosItemList[0] : null;
    const observacao = primeiroAtributoItem
        ? atributosList.find(item => item.tecaatributoid === primeiroAtributoItem.tecaatributoid) || {}
        : {};

    const valorParaInput = atributoSelecionado
        ? atributoSelecionado.tecaatributovalor
        : primeiroAtributoItem
            ? primeiroAtributoItem.tecaatributovalor
            : '';

    const valorParaInputId = atributoSelecionado
        ? atributoSelecionado.tecaatributovalorid
        : primeiroAtributoItem
            ? primeiroAtributoItem.tecaatributovaloroid
            : '';

    // quando primeiroAtributoItem estiver disponível, busca do backend
    useEffect(() => {
        if (primeiroAtributoItem && primeiroAtributoItem.tecaatributoid) {
            getAtriutoAplicarListAction('', '', '', primeiroAtributoItem.tecaatributoid, valorParaInput);
            getAtributoGeralAction(sku, produto, categoria, valorFiltro, primeiroAtributoItem.tecaatributoid, primeiroAtributoItem.tecaatributoid);
        }
        // eslint-disable-next-line
    }, [primeiroAtributoItem && primeiroAtributoItem.tecaatributoid, reload, atributosAplicarDeleteLoading]);

    // scroll quando muda a tab
    useEffect(() => {
        const APPLY_TAB_INDEX = 1;
        if (tabindex === APPLY_TAB_INDEX && rootRef.current) {
            rootRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
            if (firstTableRef.current) firstTableRef.current.scrollTo({ top: 0, behavior: 'smooth' });
            if (secondTableRef.current) secondTableRef.current.scrollTo({ top: 0, behavior: 'smooth' });
        }
    }, [tabindex]);

    // ---------- filtragem segura ----------
    // garante array seguro
    const listaSegura = Array.isArray(atributosAplicarList) ? atributosAplicarList : [];

    // define valorBusca (usar valorParaInput quando checkbox marcado)
    const valorBusca = usarMesmoValor ? (valorParaInput || '') : (valorFiltro || '');


    const safeString = (v) => {
        try {
            // String(null) -> "null", mas preferimos '' para null/undefined
            if (v === null || v === undefined) return '';
            // Se for objeto (ex: { id: 123 }), tenta extrair algo útil — senão transforma em JSON simples
            if (typeof v === 'object') {
                // se tiver campo comum sku/valor/produto dentro do objeto, adapte aqui:
                // return String(v.sku ?? v.id ?? JSON.stringify(v));
                return JSON.stringify(v);
            }
            return String(v);
        } catch (err) {
            return '';
        }
    };

    // selecionar individual
    const handleSelecionar = (sku, tecaatributovalorid) => {
        setSelecionados(prev => {
            const exists = prev.some(i =>
                i.sku === sku && i.tecaatributovalorid === tecaatributovalorid
            );

            if (exists) {
                return prev.filter(i => !(i.sku === sku && i.tecaatributovalorid === tecaatributovalorid));
            }

            return [...prev, { sku, tecaatributovalorid }];
        });
    };



    // selecionar/desselecionar todos — atua apenas nos itens visíveis (dataFiltrada)
    const handleSelecionarTodos = (_, data) => {
        const marcado = data.checked;
        setTodosSelecionados(!todosSelecionados);
        if (marcado) {
            setSelecionados(prev => {
                const skusVisiveis = atributosAplicarGeral.map(i => i.sku);
                const novo = Array.from(new Set([...prev, ...skusVisiveis]));
                return novo;
            });
        } else {
            setSelecionados(prev => prev.filter(skuItem => !atributosAplicarGeral.some(i => i.sku === skuItem)));
        }
    };

    const handleGeralBuscar = () => {
        console.log('Buscar com filtros:', { sku, categoria, valorParaInput, valorFiltro, usarMesmoValor });

        if (usarMesmoValor === true) {
            getAtributoGeralAction(sku, produto, categoria, valorParaInput, primeiroAtributoItem.tecaatributoid, primeiroAtributoItem.tecaatributoid);
        } else {
            getAtributoGeralAction(sku, produto, categoria, valorFiltro, primeiroAtributoItem.tecaatributoid, primeiroAtributoItem.tecaatributoid);
        }
    }

    const handleListBuscar = () => {
        if (primeiroAtributoItem && primeiroAtributoItem.tecaatributoid) {
            getAtriutoAplicarListAction(skuAplicados, produtoAplicados, categoriaAplicados, primeiroAtributoItem.tecaatributoid, valorParaInput);
        }
    }


    const handleExcluirSku = (skuValue, atributovalorId) => {
        console.log('Excluir SKU:', skuValue, 'AtributoValorID:', atributovalorId);
        getAtributoDeleteAction(skuValue, atributovalorId).then(() => {
            setOpenModalExcluirSKU(false);
        });
    };

    const handleEditarSku = () => {
        setLoadingEditar(true)
        const dataAtualizar = {
            itens: selecionados.map(item => ({
                ...item,
                tecaatributovaloridatual: valorParaInputId // ← adiciona o novo ID em cada item
            }))
        };

        // Envia para sua action
        getAtributoUpdateAction(dataAtualizar).then(() => {
            setLoadingEditar(false);
            setSelectedSku(false)
            setSelecionados([]); // opcional → limpa seleção após salvar
            getAtriutoAplicarListAction(primeiroAtributoItem.tecaatributoid, valorParaInput);
            getAtributoGeralAction(sku, produto, categoria, valorFiltro, primeiroAtributoItem.tecaatributoid, primeiroAtributoItem.tecaatributoid);
        });
    };


    const atributosFiltrados = atributosAplicarGeral.filter(
        item => item.tecaatributovalor !== valorParaInput
    );

    return (
        <div ref={rootRef}>
            {/* MODAL */}
            <Modal open={openModalExcluirSKU} onClose={() => setOpenModalExcluirSKU(false)}>
                <StyledModalHeader>
                    <ModalTitle>Confirmar Exclusão de SKU</ModalTitle>
                </StyledModalHeader>

                <StyledModalContent>
                    <p>Tem certeza de que deseja excluir o SKU: <b>{skuExcluir}</b> da aplicação do atributo?</p>
                </StyledModalContent>
                <StyledModalActions>
                    <Button onClick={() => setOpenModalExcluirSKU(false)}>Cancelar</Button>
                    <Button loading={atributosAplicarDeleteLoading} onClick={() => handleExcluirSku(skuExcluir, atributoValorIdExcluir)} negative>Excluir</Button>
                </StyledModalActions>
            </Modal>
            <Modal open={openModalEditar} onClose={() => setOpenModalEditar(false)}>
                <StyledModalHeader>
                    <ModalTitle>Confirmar Edição de SKU</ModalTitle>
                </StyledModalHeader>

                <StyledModalContent>
                    <p>Tem certeza de que deseja editar o(s) SKU(s): <b>{selecionados.join(", ")}</b> <b>{skuExcluir}</b> e aplicar no atributo: <b>{primeiroAtributoItem.tecaatributoid}-{observacao.tecaatributo}</b>?</p>
                </StyledModalContent>
                <StyledModalActions>
                    <Button onClick={() => setOpenModalEditar(false)}>Cancelar</Button>
                    <Button loading={atributosAplicarEditLoading} onClick={() => handleEditarSku(selecionados.join(", "))} color='green'>Editar</Button>
                </StyledModalActions>
            </Modal>

            {/* HEADER INFOS */}
            <div>
                <div style={{ width: '100%', display: 'flex', justifyContent: 'space-between' }}>
                    <span style={{ width: '100%' }}>
                        Atributo:{' '}
                        <Input
                            style={{ width: '80%' }}
                            placeholder="Atributo"
                            value={
                                primeiroAtributoItem
                                    ? `${primeiroAtributoItem.tecaatributoid}  ${observacao.tecaatributo || ''}`
                                    : ''
                            }
                            readOnly
                        />
                    </span>
                    <span style={{ width: '100%' }}>
                        Observação:{' '}
                        <Input
                            style={{ width: '80%' }}
                            placeholder="Observação"
                            value={observacao.observacao || ''}
                            readOnly
                        />
                    </span>
                </div>
                <div style={{ marginTop: '10px' }}>
                    <span style={{ marginRight: '24px' }}> Valor:</span>
                    <Input style={{ width: '40%' }} placeholder="Valor" value={valorParaInput || ''} readOnly />
                </div>

                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: 20, gap: 12 }}>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <span style={{ marginRight: 10, fontWeight: 'bold' }}>SKU:</span>
                        <Input value={skuAplicados} onChange={(e) => setSkuAplicados(e.target.value)} placeholder="SKU" />
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <span style={{ marginRight: 10, fontWeight: 'bold' }}>Produto:</span>
                        <Input value={produtoAplicados} onChange={(e) => setProdutoAplicados(e.target.value)} placeholder="Produto" />
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <span style={{ marginRight: 10, fontWeight: 'bold' }}>Categoria/Classificação:</span>
                        <Input value={categoriaAplicados} onChange={(e) => setCategoriaAplicados(e.target.value)} placeholder="Categoria/Classificação" />
                    </div>

                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <Button onClick={() => handleListBuscar()} style={{ backgroundColor: '#0078d7', color: '#fff' }}>Buscar <Icon name="search" style={{ marginLeft: '5px' }} /></Button>
                    </div>
                </div>

            </div>

            {atributosAplicarListLoading === false ? (
                <>
                    <Container ref={firstTableRef}>
                        <Table>
                            <thead>
                                <tr>
                                    <Th>SKU</Th>
                                    <Th>Produto</Th>
                                    <Th>Categoria/Classificação</Th>
                                    <Th>Valor atual</Th>
                                    <Th></Th>
                                </tr>
                            </thead>
                            <tbody>
                                {listaSegura.map((item, index) => (
                                    <tr key={item.sku ?? index}>
                                        <Td>{item.sku}</Td>
                                        <Td>{item.produto}</Td>
                                        <Td>{item.categoria}</Td>
                                        <Td>
                                            <Status valorParaInput={valorParaInput} value={item.tecaatributovalor}>
                                                {item.tecaatributovalor}
                                            </Status>
                                        </Td>
                                        <Td style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                            <ActionButton onClick={() => { console.log('Clicou no botão excluir do SKU', item.sku); setOpenModalExcluirSKU(true); setSkuExcluir(item.sku); setAtributoValorIdExcluir(item.tecaatributovalorid) }}>
                                                <Icon name="trash alternate outline" /> Excluir
                                            </ActionButton>
                                        </Td>
                                    </tr>
                                ))}
                                {listaSegura.length === 0 && (
                                    <tr>
                                        <Td colSpan={5} style={{ textAlign: 'center', padding: 20, color: '#666' }}>
                                            {atributosAplicarListLoading ? 'Carregando...' : 'Nenhum item disponível.'}
                                        </Td>
                                    </tr>
                                )}
                            </tbody>
                        </Table>
                    </Container>
                </>

            ) : (
                <div>
                    <Dimmer active inverted>
                        <Loader inverted>Carregando...</Loader>
                    </Dimmer>
                </div>
            )}

            {/* PRIMEIRA TABELA */}


            <hr />

            <div style={{ backgroundColor: '#E1E1E1', margin: '-10px', padding: '10px', borderRadius: '8px' }}>
                {/* FILTROS PARA BUSCA */}
                <div>
                    <p style={{ color: '#102E3E', fontWeight: 'bold' }}>Busca para identificar novos produtos a serem APLICADOS</p>
                </div>

                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: 20, gap: 12 }}>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <span style={{ marginRight: 10, fontWeight: 'bold' }}>SKU:</span>
                        <Input value={sku} onChange={(e) => setSku(e.target.value)} placeholder="SKU" />
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <span style={{ marginRight: 10, fontWeight: 'bold' }}>Produto:</span>
                        <Input value={produto} onChange={(e) => setProduto(e.target.value)} placeholder="Produto" />
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <span style={{ marginRight: 10, fontWeight: 'bold' }}>Categoria/Classificação:</span>
                        <Input value={categoria} onChange={(e) => setCategoria(e.target.value)} placeholder="Categoria/Classificação" />
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <span style={{ marginRight: 10, fontWeight: 'bold' }}>Valor:</span>
                        <Input

                            placeholder="Valor"
                            value={usarMesmoValor ? (valorParaInput || '') : valorFiltro}
                            onChange={(e) => setValorFiltro(e.target.value)}
                            disabled={usarMesmoValor}
                        />
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <span style={{ marginRight: 10, fontWeight: 'bold' }}>Mesmo valor:</span>
                        <Checkbox
                            checked={usarMesmoValor}
                            onChange={(e, data) => setUsarMesmoValor(Boolean(data.checked))}
                        />
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <Button onClick={() => handleGeralBuscar()} style={{ backgroundColor: '#0078d7', color: '#fff' }}>Buscar <Icon name="search" style={{ marginLeft: '5px' }} /></Button>
                    </div>
                </div>

                <Container ref={secondTableRef}>
                    <Table style={{ backgroundColor: '#E1E1E1' }}>
                        <thead style={{ backgroundColor: '#E1E1E1' }}>
                            <tr>
                                <Th>SKU</Th>
                                <Th>Produto</Th>
                                <Th>Categoria/Classificação</Th>
                                <Th>Valor atual</Th>
                                <Th>
                                    <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                                        <span style={{ marginRight: 5, width: '100px' }}>Selecionar Tudo</span>
                                        <Checkbox
                                            checked={todosSelecionados}
                                            onChange={handleSelecionarTodos}
                                        // disabled={dataFiltrada.length === 0}
                                        />
                                    </div>
                                </Th>
                            </tr>
                        </thead>

                        <tbody style={{ backgroundColor: '#E1E1E1' }}>
                            {atributosFiltrados.map((item, index) => {
                                const isSelected = selecionados.some(i =>
                                    i.sku === item.sku && i.tecaatributovalorid === item.tecaatributovalorid
                                );
                                return (
                                    !atributosAplicarGeralLoading && (
                                        <Tr key={`${item.sku}-${item.tecaatributovalor}-${index}`} selected={isSelected}>
                                            <Td>{item.sku}</Td>
                                            <Td>{item.produto}</Td>
                                            <Td>{item.categoria}</Td>
                                            <Td style={{ width: '300px' }}>
                                                <Status valorParaInput={valorParaInput} value={item.tecaatributovalor}>
                                                    {item.tecaatributovalor}
                                                </Status>
                                            </Td>
                                            <Td>
                                                <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                                    <ActionButtonSelect
                                                        selected={isSelected}
                                                        onClick={() => {
                                                            handleSelecionar(item.sku, item.tecaatributovalorid);
                                                            console.log('DADOS ->', item.sku, item.tecaatributovalorid, valorParaInputId);
                                                        }}
                                                    >
                                                        {isSelected ? 'Cancelar' : 'Selecionar'}
                                                    </ActionButtonSelect>
                                                </div>
                                            </Td>
                                        </Tr>
                                    )
                                );
                            })}
                            {atributosAplicarGeral.length === 0 && (
                                !atributosAplicarGeralLoading && (
                                    sku ? (
                                        <>
                                            <tr>
                                                <Td colSpan={5} style={{ textAlign: 'center', padding: 20, color: '#666' }}>
                                                    Nenhum item encontrado para o Sku informado, deseja aplicá-lo no valor atual?
                                                </Td>
                                            </tr>
                                            <Tr selected={selectedSku}>
                                                <Td>{sku}</Td>
                                                <Td>-</Td>
                                                <Td></Td>
                                                <Td style={{ width: '300px' }}>
                                                    Sem Atributo
                                                </Td>
                                                <Td>
                                                    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                                        <ActionButtonSelect
                                                            selected={selectedSku}
                                                            onClick={() => {
                                                                handleSelecionar(sku, null);
                                                                setSelectedSku(!selectedSku);
                                                                console.log('DADOS ->', sku, null, valorParaInputId);
                                                            }}
                                                        >
                                                            {selectedSku ? 'Cancelar' : 'Selecionar'}
                                                        </ActionButtonSelect>
                                                    </div>
                                                </Td>
                                            </Tr>
                                        </>

                                    ) : (
                                        <tr>
                                            <Td colSpan={5} style={{ textAlign: 'center', padding: 20, color: '#666' }}>
                                                Nenhum item encontrado para o filtro informado.
                                            </Td>
                                        </tr>
                                    )
                                )
                            )}
                            {atributosAplicarGeralLoading && (
                                <tr>
                                    <Td style={{ textAlign: 'center', color: '#666' }}>
                                        <div>
                                            <Loader style={{ marginTop: '200px' }} active>carregando...</Loader>
                                        </div>
                                    </Td>
                                </tr>
                            )}

                        </tbody>
                    </Table>
                </Container>

                {/* BOTÃO FINAL */}
                <div style={{ marginTop: 20, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <Button
                        style={{ backgroundColor: '#0078FF', color: 'white' }}
                        onMouseOver={(e) => (e.currentTarget.style.backgroundColor = '#0063CC')}
                        onMouseOut={(e) => (e.currentTarget.style.backgroundColor = '#0078FF')}
                        onClick={() => handleEditarSku()}
                        disabled={selecionados.length > 0 ? false : true}
                        loading={loadingEditar}
                    >
                        Acrescentar Produtos <Icon name='long arrow alternate up' color='white' />
                    </Button>
                </div>
            </div>
        </div>
    );
}

// Conecta ao Redux
const mapStateToProps = (state) => ({
    tabindex: state.EspacoTecaReducer.tabindex,
    userid: state.LoginReducer.userid,
    atributosItemList: state.EspacoTecaReducer.atributosItemList,
    atributosList: state.EspacoTecaReducer.atributosList,
    atributoSelecionado: state.EspacoTecaReducer.atributoSelecionado,
    atributosAplicarList: state.EspacoTecaReducer.atributosAplicarList,
    atributosAplicarListLoading: state.EspacoTecaReducer.atributosAplicarListLoading,
    atributosAplicarGeral: state.EspacoTecaReducer.atributosAplicarGeral,
    atributosAplicarGeralLoading: state.EspacoTecaReducer.atributosAplicarGeralLoading,
    atributosAplicarDelete: state.EspacoTecaReducer.atributosAplicarDelete,
    atributosAplicarDeleteLoading: state.EspacoTecaReducer.atributosAplicarDeleteLoading,
    atributosAplicarEdit: state.EspacoTecaReducer.atributosAplicarEdit,
    atributosAplicarEditLoading: state.EspacoTecaReducer.atributosAplicarEditLoading,
});

export default withRouter(connect(mapStateToProps, { getAtriutoAplicarListAction, getAtributoGeralAction, getAtributoDeleteAction, getAtributoUpdateAction })(Aplicar));
